'use client';

import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { sendOTPService } from './services';
import { SejamKeys } from './keys';
import { SejamSendOtp } from './types';
export function useSejamSendOtp(props: SejamSendOtp['Props']): UseMutationResult<SejamSendOtp['Response'], Error, void, unknown> {
  return useMutation({
    mutationFn: () => sendOTPService(),
    mutationKey: [SejamKeys.sendOtp],
    onSuccess: () => {
      if (props.onSuccess) props.onSuccess();
    },
    onError: (error: SejamSendOtp['Error'] & Error) => {
      if (props.onError) {
        props.onError(error);
      }
    }
  });
}